
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/address-book",
      function () {
        return require("private-next-pages/address-book.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/address-book"])
      });
    }
  